import { useSelector } from 'react-redux';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { getProductLevelFromApiNameString, getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { hasPurchaseMotionsFailedSelector, isMerchCardCTAsDataLoadingSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { useSkuAdditionalUnits } from '../merch-card/useSkuAdditionalUnits';
import FallbackMerchCardCTAsContainer from './FallbackMerchCardCTAsContainer';
import MerchCardCTAsContainer from './MerchCardCTAsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const HC0124MerchCard = ({
  upgradePointApiName,
  upgradeData,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  const productLine = getProductLineFromApiNameString(upgradePointApiName);
  const productLevel = getProductLevelFromApiNameString(upgradePointApiName);
  const {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const isMerchCardCTAsDataLoading = useSelector(isMerchCardCTAsDataLoadingSelector);
  const hasPurchaseMotionsFailed = useSelector(hasPurchaseMotionsFailedSelector);
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: isMerchCardCTAsDataLoading,
    isError: hasPurchaseMotionsFailed,
    heights: [47],
    Content: MerchCardCTAsContainer,
    contentProps: {
      additionalUnitQuantity: isAdditionalUnitSkuIdAQuantityPack ? additionalUnitQuantity : 0,
      additionalUnitSkuId,
      ctaStyles: {
        width: '100%'
      },
      productLine,
      queryParamTerm: ANNUAL,
      skuId,
      skipMCConfirmationPage: true,
      containterStyle: {
        padding: '0'
      },
      isHC0124Variant: true,
      trackingSource: 'HC0124MerchCard',
      overridePurchaseMotions: purchaseMotions,
      overrideUpgradeData: upgradeData,
      onPurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
      location: UPGRADE_PAGE
    },
    ErrorContent: FallbackMerchCardCTAsContainer,
    errorContentProps: {
      skuId
    }
  });
};
export default HC0124MerchCard;